import {ChangeDetectionStrategy,ChangeDetectorRef,Component,ComponentRef,EventEmitter,Input,Output,QueryList,ViewChildren} from '@angular/core';
import {LoaderDirective} from 'nm-socle-application/app/shared/directives/loader-directive';
import {FormComponentI} from 'nm-socle-application/app/shared/interfaces/form-component-i.interface';
import {AbstractComponent} from 'nm-socle-application/app/shared/models/abstract-component';
import {CustomerConfig,CustomerTemplateState,StateMiscArgument} from 'nm-socle-application/app/shared/models/customer-config';
import {CustomerStyle} from 'nm-socle-application/app/shared/models/customer-style';
import {InternalStateEvent} from 'nm-socle-application/app/shared/models/internal-state-event';
import {TemplateCurrentState} from 'nm-socle-application/app/shared/models/template-current-state';
import {ComponentsManagerService} from 'nm-socle-application/app/shared/services/component-manager.service';
import {TemplateInitService} from 'nm-socle-application/app/shared/services/template-init.service';
import {combineLatest} from 'rxjs/observable/combineLatest';

@Component({
    selector: 'home-page-template',
    templateUrl: './home-page-template.component.html',
    styleUrls: ['./home-page-template.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class HomePageTemplateComponent  extends AbstractComponent implements FormComponentI {
    public static ICON_TOP:string = 'top';
    public static ICON_BOTTOM:string = 'bottom';
    public static ICON_LEFT:string = 'left';
    public static ICON_RIGHT:string = 'right';

    public currentState:TemplateCurrentState;
    public states: CustomerTemplateState[] = [];

    @Output() public closeEvent: EventEmitter<any> = new EventEmitter();
    @Output() public internalStateEvent: EventEmitter<InternalStateEvent> = new EventEmitter();
    @Input() public misc:StateMiscArgument[] = [];

    @ViewChildren(LoaderDirective) public loaderHosts:QueryList<LoaderDirective>;
    protected _mainRef:ComponentRef<Component>;

    public customStyles:any = {};
    protected _customerConfig:CustomerConfig;

    public hasSide:boolean;
    protected _leftSideRef:ComponentRef<Component>;
    protected _rightSideRef:ComponentRef<Component>;

    public get leftSideSize():string {
        return this._getSideSize('left');
    }

    public get rightSideSize():string {
        return this._getSideSize('right');
    }

    constructor(
        protected _cd:ChangeDetectorRef,
        protected _templateInitService: TemplateInitService,
        protected _componentsManagerService: ComponentsManagerService,
    ) {
        super(_cd);
    }



    public ngOnInit() {
        super.ngOnInit();

        this.addSub = combineLatest(this._templateInitService.templateStates$, this._templateInitService.currentState$).subscribe(([states, currentState]) => {
            this.states = states;
            this.currentState = currentState;

            this._initView();
        });

        this.addSub = this._templateInitService.customerConfig$.subscribe(custConf => {
            this._customerConfig = custConf;
            this.hasSide = this._customerConfig.homePage.hasSide;

            this._parseTemplateStyles(this._customerConfig.styles);
        });

        this.markForCheck();
    }

    public ngAfterViewInit() {
        this._initView();
    }

    public getCurrentState():CustomerTemplateState {
        let curState:CustomerTemplateState;

        if(this.states.length > 0 && this.currentState != undefined) {
            for(let cS of this.states) {
                if(cS.name == this.currentState.state) {
                    curState = cS;
                    break;
                }
            }
        }

        return curState;
    }

    protected _initView() {
        if(this.currentState != undefined && this.currentState.state != '' && this.states.length > 0 && this.loaderHosts != undefined) {
            let currentState:CustomerTemplateState = this.getCurrentState();

            if(currentState != undefined) {
                this.loaderHosts.forEach((loader, index) => {
                    let refName:string = '_'+loader.loaderName+'Ref';

                    if (this[refName] != undefined) {
                        this[refName].destroy();
                    }

                    let className:string;

                    if(loader.loaderName != 'main' && currentState[loader.loaderName] != undefined) {
                        className = currentState[loader.loaderName].type;
                    } else if(loader.loaderName == 'main') {
                        className = 'FormContainer';
                    }
                    
                    if(className != undefined) {
                        this[refName] = this._componentsManagerService.createComponent(this[refName], className, loader);

                        if(this[refName] != undefined) {
                            if(loader.loaderName == 'main') {
                                this[refName].instance['componentName'] = currentState[loader.loaderName]['type'];
                            }

                            for(let prop in currentState[loader.loaderName]) {
                                this[refName].instance[prop] = currentState[loader.loaderName][prop];
                            }

                            if(this[refName].instance['closeEvent'] != undefined) {
                                this._subs.push(this[refName].instance['closeEvent'].subscribe(evt => {
                                    this.closeEvent.emit(evt);
                                }));
                            }
                            
                            this[refName].changeDetectorRef.detectChanges();
                            this.markForCheck();
                        }

                        this.markForCheck();
                    }
                });
            }
        }

        this.markForCheck();
    }

    protected _parseTemplateStyles(style:any) {
        this.customStyles = this._templateInitService.parseCustomerStyle(style, CustomerStyle.sizesColorsBorders);

        this.markForCheck();
    }

    protected _getSideSize(side:string):string {
        let currentState:CustomerTemplateState = this.getCurrentState();

        return currentState != undefined && currentState[side + 'Side'] != undefined?currentState[side + 'Side'].size:'';
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/shared/templates/home-page-template/home-page-template.component.ts